import React from 'react';
import { Box, Slider, Typography, Grid } from '@mui/material';
import CustomTile from './CustomTile'; // Import CustomTile if it's in a separate file
import { abbreviateNumber, formatValue } from '../../utils';

const TokenSlider = React.memo(({
  token,
  weight,
  maxWeight,
  onChange,
  //rocketFiSubscribed,
  //totalDistributed,
  // decimals,
  label
}) => (
  <CustomTile>
    <Box sx={{
      width: "100%",
    }}>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body" align="left">
          {label}
        </Typography>
        <Typography variant="body" align="right">
          {weight}%
        </Typography>
      </Box>
      <div style={{ marginTop: "5px", padding: '10px' }}>
      <Slider
        value={weight}
        onChange={onChange}
        max={maxWeight}
        valueLabelDisplay="auto"
        aria-labelledby={`${token}-slider`}
      />
      </div>
    </Box>

  </CustomTile>
));

export default TokenSlider;